import { Box, useMediaQuery } from '@mui/material'
import Mobile from './mobile'
import Desktop from './desktop'

const PageFilter = ({ openModal, setOpenModal }) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  return (
    <Box>
        {isXsScreen
          ? <Mobile openModal={openModal} setOpenModal={setOpenModal}/>
          : <Desktop/>}
    </Box>
  )
}

export default PageFilter
